/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set } from 'lodash-es';
import { sendSignature } from '@/services/api/document/document';

// initial state
const state = {
  message: {
    cc: null,
    comment: null,
  },
};

// getters
const getters = {
  message: (state) => state.message,
};

// actions
const actions = {
  send({ state }, id) {
    return sendSignature(id, state.message);
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
